import * as React from "react";

interface ArchivedIconProps {
    className?: string;
    onClick?: () => void;
}

export class ArchivedIcon extends React.Component<ArchivedIconProps> {
    render() {
        return (
            <div {...this.props}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 14C1 14.5531 1.44687 15 2 15H14C14.5531 15 15 14.5531 15 14V5H1V14ZM6 7.375C6 7.16875 6.16875 7 6.375 7H9.625C9.83125 7 10 7.16875 10 7.375V7.625C10 7.83125 9.83125 8 9.625 8H6.375C6.16875 8 6 7.83125 6 7.625V7.375ZM15 1H1C0.446875 1 0 1.44687 0 2V3.5C0 3.775 0.225 4 0.5 4H15.5C15.775 4 16 3.775 16 3.5V2C16 1.44687 15.5531 1 15 1Z" fill="#333333" />
                    <path d="M1 14C1 14.5531 1.44687 15 2 15H14C14.5531 15 15 14.5531 15 14V5H1V14ZM6 7.375C6 7.16875 6.16875 7 6.375 7H9.625C9.83125 7 10 7.16875 10 7.375V7.625C10 7.83125 9.83125 8 9.625 8H6.375C6.16875 8 6 7.83125 6 7.625V7.375ZM15 1H1C0.446875 1 0 1.44687 0 2V3.5C0 3.775 0.225 4 0.5 4H15.5C15.775 4 16 3.775 16 3.5V2C16 1.44687 15.5531 1 15 1Z" fill="white" opacity="0.25" />
                </svg>
            </div>
        );
    }
}

